import { FC, useTransition } from "react"
import { FormikProps, Form } from "formik"

import {
  FormikCheckBox,
  FormikNotesArea,
  StatusErrorMessage,
} from "../../../../../../../components/widgets"

import { DOCLabelSiteDetailsPanel, useDOCLabelFormView } from '.';

import { convertDLMApplication2Request, processDLMPayload, RESUBMIT_MODES } from "../core/_helpers";
import { saveDraftDLMApplication } from "../../../../_requests";

import { IDOCLabelApplication } from "../core"
import { DOCLabelFormApplicationDetails } from "./DOCLabelFormApplicationDetails";
import { getErrorMessage } from "../../../../../../../components/helpers";
import { MSG_ACK_ABOVE, MSG_FINALCONFIRM_1, MSG_FINALCONFIRM_2, MSG_FINALCONFIRM_LINK, MSG_NOTE_CHARGES } from "../../../../../../../constants";
import { Link } from "react-router-dom";
import { SubmitButtonRow } from "../../../../../../../components/layout";

const DOCLabelRequestModalForm: FC<FormikProps<IDOCLabelApplication>> = ({status, values, setStatus}) => {

  const { initValues, cancelForm, setInitValues, dlmTypeCode } = useDOCLabelFormView();
  const { requestId, requestMode, appType, certID, dlmTypeId } = initValues;

  const [ savingDraft, saveDraft] = useTransition();

  const onDraftClick = () => {
    const payload = processDLMPayload(values, requestId, 'draft', appType,dlmTypeId, certID, dlmTypeCode);
    saveDraft(() => {
      saveDraftDLMApplication(payload)
      .then( res => {
        if (! (res?.data && res.data?.success && res.data?.application)) {
          setStatus((res?.data && res?.data.message) ? res.data.message : 'Draft Error: something happened');
          return;
        }
        // resetInitValues to returned 'application' values
        setInitValues(convertDLMApplication2Request(initValues, res.data.application, requestMode));
      })
      .catch(err => {
        setStatus(getErrorMessage(err));
      })
    });
  }

  return (
  <Form id='kt_doclabel_request_modal_form' className='form' noValidate>
    <div
      id='kt_doclabel_request_modal_scroll'
      className='d-flex flex-column gap-2 p-2'
    >
      { (! ['edit_site'].includes(requestMode)) &&
      <DOCLabelFormApplicationDetails />
      }

      <DOCLabelSiteDetailsPanel />
      { (RESUBMIT_MODES.includes(requestMode)) &&
      <>
      <div className='separator border-gray-200 my-2'></div>
      <FormikNotesArea />
      </>
      }

      <div className="fv-row mb-4 mt-2">
        <div className='fw-bold text-danger text-opacity-50 fs-6 mb-2'>
          CONFIRM DETAILS
        </div>

        <div className="rounded border border-danger border-opacity-75 p-4">
          <div className="fs-7">
          <ol>
            <li>{MSG_FINALCONFIRM_1}</li>
            <li>
              {MSG_FINALCONFIRM_2} (<Link to={MSG_FINALCONFIRM_LINK} target='_blank'>{MSG_FINALCONFIRM_LINK}</Link>).
            </li>
          </ol>
          </div>
          <div className="fs-7">
            {MSG_NOTE_CHARGES}
          </div>
          <FormikCheckBox name="confirm" label={MSG_ACK_ABOVE} />
        </div>
      </div>

      <StatusErrorMessage status={status} />
      <div className='separator border-gray-200 my-0'></div>
      <SubmitButtonRow
        cancelText="Discard"
        doClose={cancelForm}
        onDraftClick={(! RESUBMIT_MODES.includes(requestMode)) ? onDraftClick : undefined}
        savingDraft={savingDraft}
      />
    </div>
  </Form>
  )
}

export { DOCLabelRequestModalForm }